import styles from "./Load.module.css";

const Load = () => {
  return (
    <div className={styles.loadingContainer}>
      <div className={styles.loadingContent}>
        <div className={styles.loadingLogo}>ELITE VACANCES</div>
        <div className={styles.loadingSpinner}>
          <div className={styles.spinnerCircle}></div>
          <div className={styles.spinnerCircle}></div>
          <div className={styles.spinnerCircle}></div>
        </div>
      </div>
    </div>
  );
};

export default Load;
